import { addError, addLoading, getLoading, removeLoadingAndError } from '../../core/redux/api/module';
import { hasTrippedBreaker, updateBreaker } from '../../core/redux/api/circuitBreaker/module';
import { IAppState } from '../../core/redux/IAppState';
import { ApiReducer, makeApiAction, makeApiReducer, RsaaTypes } from '../../core/redux/api/reduxStandardApiAction';
import { apiGetReleaseNotes } from '../../core/redux/api/endpoints';
import { ACTION_TYPE } from '../../core/redux/actionType';
import { AppDocItem } from '../appDocItem';
import { assoc } from '../../language/module';


const KEY_ACTION = ACTION_TYPE.LOAD_RELEASE_NOTES_REQUEST;
const ACTIONS    = [
  ACTION_TYPE.LOAD_RELEASE_NOTES_REQUEST,
  ACTION_TYPE.LOAD_RELEASE_NOTES_RESPONSE,
  ACTION_TYPE.LOAD_RELEASE_NOTES_ERROR,
];


export const loadReleaseNotesAction = () => makeApiAction(
  {
    method:   'GET',
    endpoint: apiGetReleaseNotes,
    headers:  (state: IAppState) => ({
      'content-type':  'application/json',
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    types:    ACTIONS as RsaaTypes,
    bailout:  state => !!getLoading(state, KEY_ACTION, KEY_ACTION) || hasTrippedBreaker(state, KEY_ACTION),
  },
);


const reducer: ApiReducer<AppDocItem[]> = (state, action, error, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  if (error) {
    return addError(withBreaker, KEY_ACTION, KEY_ACTION, error);
  }

  const noLoadingOrError = removeLoadingAndError(withBreaker, KEY_ACTION, KEY_ACTION);

  console.log(payload)

  return assoc('releaseNotes', payload, noLoadingOrError);
};


export const loadReleaseNotesReducer = makeApiReducer<AppDocItem[]>(ACTIONS, KEY_ACTION, reducer);
